import Navbar from "./Navbar";
import { Outlet } from "react-router-dom";

const DefaultOpenLayout = () => {
	return (
		<div style={{ width: "100%" }}>
			<Navbar />
			<Outlet />
		</div>
	);
};

export default DefaultOpenLayout;
